import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ApiConfigService } from '../../../../state/core/services/api-config/api-config.service';
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../../../../state/core/services/base/base.service';
import { TokenStorageService } from '../../../../state/core/services/token-storage/token-storage.service';
import { catchError, map } from 'rxjs/operators';
import { ToasterService } from '../../../../core/services/toaster.service';
@Injectable({
  providedIn: 'root'
})
export class ShiftInfoMainService extends BaseService {

  private showSidebar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  _showSidebar = null;
  public refresh$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  _refresh = true;
  constructor(
    protected httpClient: HttpClient,
    public apiConfig: ApiConfigService,
    protected tokenStorage: TokenStorageService,
    private toasterService: ToasterService
  ) {
    super(httpClient, tokenStorage);
    }

  showSidebar(value: boolean) {
    this._showSidebar = value;
    if (value) {
      this.showNotificationSidebar(false);
    }
    this.showSidebar$.next(value);
  }
  isSideBarOpened() {
    return this._showSidebar;
  }

  getShowSidebarListener(): Observable<any> {
    return this.showSidebar$.asObservable();
  }


  private showNotificationSidebar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  _showNotificationSidebar = null;
  showNotificationSidebar(value: boolean) {
    this._showNotificationSidebar = value;
    this.showNotificationSidebar$.next(value);
    if (value) {
      this.showSidebar(false);
    }
  }

  isNotificationSideBarOpened() {
    return this._showNotificationSidebar;
  }

  getshowNotificationSidebarListener(): Observable<any> {
    return this.showNotificationSidebar$.asObservable();
  }

  refresh() {
    return this.refresh$.asObservable();
    // this.refresh$.next(true);
  }
  public getPendingFormList<T>(user_id): Observable<any> {
    const url = `${this.apiConfig.getApiUrl()}timesheet/check-pending-mandatory-form/${user_id}`;
    return this.get(url).pipe(
      map((data: any) => {
        return { success: true, data };
      }),
      catchError((data) => {
        this.toasterService.errorShow(data.error.message, '', { closeButton: true, timeOut: 3000 });
        return of({ success: false, data });
      })
    )
  }
   

}
